/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserOrganizationRead } from './UserOrganizationRead';
import {
    UserOrganizationReadFromJSON,
    UserOrganizationReadFromJSONTyped,
    UserOrganizationReadToJSON,
    UserOrganizationReadToJSONTyped,
} from './UserOrganizationRead';

/**
 * 
 * @export
 * @interface UserRead
 */
export interface UserRead {
    /**
     * 
     * @type {string}
     * @memberof UserRead
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof UserRead
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRead
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRead
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRead
     */
    last_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserRead
     */
    grade?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserRead
     */
    avatar_image?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserRead
     */
    is_active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserRead
     */
    has_avatar?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserRead
     */
    id: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserRead
     */
    role_ids?: Array<number>;
    /**
     * The user has an organization where every role row is deactivated (/users/me only; role_ids lists active rows, so this is how the app tells a deactivated member apart from a user who was never added)
     * @type {boolean}
     * @memberof UserRead
     */
    has_inactive_memberships?: boolean;
    /**
     * 
     * @type {Array<UserOrganizationRead>}
     * @memberof UserRead
     */
    organizations?: Array<UserOrganizationRead> | null;
    /**
     * 
     * @type {Date}
     * @memberof UserRead
     */
    created_at?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UserRead
     */
    last_login?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UserRead
     */
    last_active?: Date | null;
}

/**
 * Check if a given object implements the UserRead interface.
 */
export function instanceOfUserRead(value: object): value is UserRead {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UserReadFromJSON(json: any): UserRead {
    return UserReadFromJSONTyped(json, false);
}

export function UserReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRead {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'email': json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'grade': json['grade'] == null ? undefined : json['grade'],
        'avatar_image': json['avatar_image'] == null ? undefined : json['avatar_image'],
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
        'has_avatar': json['has_avatar'] == null ? undefined : json['has_avatar'],
        'id': json['id'],
        'role_ids': json['role_ids'] == null ? undefined : json['role_ids'],
        'has_inactive_memberships': json['has_inactive_memberships'] == null ? undefined : json['has_inactive_memberships'],
        'organizations': json['organizations'] == null ? undefined : ((json['organizations'] as Array<any>).map(UserOrganizationReadFromJSON)),
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'last_login': json['last_login'] == null ? undefined : (new Date(json['last_login'])),
        'last_active': json['last_active'] == null ? undefined : (new Date(json['last_active'])),
    };
}

export function UserReadToJSON(json: any): UserRead {
    return UserReadToJSONTyped(json, false);
}

export function UserReadToJSONTyped(value?: UserRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'email': value['email'],
        'phone': value['phone'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'grade': value['grade'],
        'avatar_image': value['avatar_image'],
        'is_active': value['is_active'],
        'has_avatar': value['has_avatar'],
        'id': value['id'],
        'role_ids': value['role_ids'],
        'has_inactive_memberships': value['has_inactive_memberships'],
        'organizations': value['organizations'] == null ? undefined : ((value['organizations'] as Array<any>).map(UserOrganizationReadToJSON)),
        'created_at': value['created_at'] == null ? undefined : ((value['created_at'] as any).toISOString()),
        'last_login': value['last_login'] == null ? undefined : ((value['last_login'] as any).toISOString()),
        'last_active': value['last_active'] == null ? undefined : ((value['last_active'] as any).toISOString()),
    };
}

